import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  TextField,
  Button,
  Grid,
  IconButton,
  Typography,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  useMediaQuery,
  Snackbar,
  Alert,
  styled,
  useTheme,
  CardContent,
  Card,
  Checkbox,
  FormControlLabel,
  Link,
} from "@mui/material";

import callBackFormSubmit from "../services/callBackFormSu";

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    borderRadius: "12px",
    backgroundColor: "white",
    "& fieldset": {
      borderColor: "#e0e0e0",
    },
    "&:hover fieldset": {
      borderColor: "#00cc87",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#00cc87",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#666",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#00cc87",
  },
}));

const StyledButton = styled(Button)(({ theme }) => ({
  borderRadius: "8px",
  padding: "5px 30px",
  fontSize: "16px",
  marginTop: "20px",
  width: "150px",
  fontWeight: "bold",
  textTransform: "none",
  background: "#00cc87",
  boxShadow: "0 8px 20px rgba(211, 47, 47, 0.1)",
  "&:hover": {
    background: "#0265fe",
    transform: "translateY(-2px)",
  },
  transition: "all 0.3s ease",
}));

const loanTypes = [
  "Select Loan Type",
  "Used Commercial Vehicle Loan",
  "Used Car Loan",
  "Used Truck Loan",
  "EV Car Loan",
  "EV Truck Loan",
  "EV 3 Wheeler Loan",
  "Business Loan",
];

export default function CallBackForm({ callBackFormLabels }) {
  const [formData, setFormData] = useState({
    name: "",
    "email-address": "",
    "phone-number": "",
    "loan-type": "",
    state: "",
    "pin-code": "",
    "form-name": "Contact Us Loan Form",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // const handleSubmit = async (event) => {
  //   event.preventDefault();
  //   setIsSubmitting(true);

  //   try {
  //     await callBackFormSubmit(formData);
  //     setSnackbar({
  //       open: true,
  //       message: "Application submitted successfully!",
  //       severity: "success",
  //     });
  //     // Reset form after successful submission
  //     setFormData({
  //       name: "",
  //       "email-address": "",
  //       "phone-number": "",
  //       "loan-type": "",
  //       state: "",
  //       "pin-code": "",
  //     });
  //   } catch (error) {
  //     console.error("Submission error:", error);
  //     setSnackbar({
  //       open: true,
  //       message: "Failed to submit application. Please try again.",
  //       severity: "error",
  //     });
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      // First API call (your existing one)
      await callBackFormSubmit(formData);

      // Second API call for email (new)
      const emailFormData = new FormData();

      // Map your form fields to the email API format
      emailFormData.append("smtpEmail", "psnfinanceblr@gmail.com");
      emailFormData.append("appPassword", "pnyl ysdr vfxk avmj");
      emailFormData.append("toEmail", "psnfinanceblr@gmail.com");
      emailFormData.append(
        "subject",
        `New Loan Application - ${formData["loan-type"]}`,
      );

      // Create message content
      const message = `New loan application received.\n\nName: ${formData.name}\nEmail: ${formData["email-address"]}\nPhone: ${formData["phone-number"]}\nLoan Type: ${formData["loan-type"]}\nState: ${formData.state}\nPin Code: ${formData["pin-code"]}`;

      const html = `
        <h3>New Loan Application</h3>
        <p><strong>Name:</strong> ${formData.name}</p>
        <p><strong>Email:</strong> ${formData["email-address"]}</p>
        <p><strong>Phone:</strong> ${formData["phone-number"]}</p>
        <p><strong>Loan Type:</strong> ${formData["loan-type"]}</p>
        <p><strong>State:</strong> ${formData.state}</p>
        <p><strong>Pin Code:</strong> ${formData["pin-code"]}</p>
      `;

      emailFormData.append("message", message);
      emailFormData.append("html", html);

      // Send email
      const emailResponse = await fetch(
        "https://email-sender.backendprod.com/api/send-email",
        {
          method: "POST",
          headers: {
            "X-API-Key": "Dinesh@@@@",
          },
          body: emailFormData,
        },
      );

      const emailResult = await emailResponse.json();

      if (!emailResult.success) {
        console.error("Email sending failed:", emailResult.error);
        // You might want to handle this differently than throwing an error
      }

      // Show success message
      setSnackbar({
        open: true,
        message: "Application submitted successfully!",
        severity: "success",
      });

      // Reset form after successful submission
      setFormData({
        name: "",
        "email-address": "",
        "phone-number": "",
        "loan-type": "",
        state: "",
        "pin-code": "",
        "form-name": "Contact Us Loan Form",
      });
    } catch (error) {
      console.error("Submission error:", error);
      setSnackbar({
        open: true,
        message: "Failed to submit application. Please try again.",
        severity: "error",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  useEffect(() => {
    if (callBackFormLabels) {
      setFormData((prev) => ({
        ...prev,
        loanType: callBackFormLabels,
      }));
    }
  }, [callBackFormLabels]);

  return (
    <>
      <Stack direction={isMobile ? "column" : "row"} alignItems="center">
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            mt: 1,

            width: { xs: "100%", md: "80%" },
            borderRadius: "20px",
            p: { xs: 3, md: 5 },
          }}
        >
          <Stack spacing={2} sx={{ mb: { xs: 1, md: 2 } }}>
            <StyledTextField
              required
              fullWidth
              size={isMobile ? "small" : "medium"}
              id="name"
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              variant="outlined"
            />

            <StyledTextField
              size={isMobile ? "small" : "medium"}
              required
              fullWidth
              id="email"
              label="Email"
              name="email-address"
              type="email"
              value={formData.email}
              onChange={handleChange}
              variant="outlined"
            />
          </Stack>

          <Stack spacing={2} alignItems="center" sx={{ mb: { xs: 1, md: 2 } }}>
            <StyledTextField
              required
              fullWidth
              size={isMobile ? "small" : "medium"}
              id="mobile"
              label="Mobile No"
              name="phone-number"
              type="tel"
              value={formData.mobile}
              onChange={handleChange}
              variant="outlined"
              inputProps={{ pattern: "[0-9]{10}" }}
            />

            <FormControl
              fullWidth
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  borderRadius: "12px",
                  backgroundColor: "white",
                  "& fieldset": {
                    borderColor: "#e0e0e0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#00cc87",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#00cc87",
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "#666",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#00cc87",
                },
              }}
            >
              <InputLabel id="loan-type-label">Loan Type *</InputLabel>
              <Select
                required
                size={isMobile ? "small" : "medium"}
                labelId="loan-type-label"
                id="loanType"
                name="loan-type"
                value={formData.loanType}
                onChange={handleChange}
                label="Loan Type *"
                sx={{
                  borderRadius: "12px",
                  fontSize: isMobile ? "14px" : "16px",
                }}
              >
                {loanTypes.map((type) => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Stack>

          <Stack
            spacing={2}
            direction={{ xs: "column", md: "row" }}
            alignItems="center"
            sx={{ mb: { xs: 0, md: 2 } }}
          >
            <StyledTextField
              required
              fullWidth
              size={isMobile ? "small" : "medium"}
              id="state"
              label="State"
              name="state"
              value={formData.state}
              onChange={handleChange}
              variant="outlined"
            />

            <StyledTextField
              required
              fullWidth
              size={isMobile ? "small" : "medium"}
              id="pincode"
              label="Pin code"
              name="pin-code"
              value={formData.pincode}
              onChange={handleChange}
              variant="outlined"
              inputProps={{ pattern: "[0-9]{6}" }}
            />
          </Stack>

          <Box sx={{ mt: 2, mb: 1 }}>
            <FormControlLabel
              control={<Checkbox required color="default" />}
              sx={{ "& .MuiFormControlLabel-asterisk": { display: "none" } }}
              label={
                <Typography
                  component="span"
                  variant="body1"
                  sx={{
                    display: "inline",
                    fontSize: { xs: "12px", md: "14px" },
                    textAlign: "left",
                  }}
                >
                  By continuing, you agree to provide your authorization to PSN
                  Finance, PSN Group, and its affiliated entities to store and
                  process your data as per the{" "}
                  <Link
                    component={RouterLink}
                    to="/privacy-policy"
                    underline="hover"
                    color="primary"
                  >
                    Privacy Policy*
                  </Link>
                  .
                </Typography>
              }
            />
          </Box>

          <Grid item xs={12}>
            <Box sx={{ display: "flex", justifyContent: "center", mt: 1 }}>
              <StyledButton
                type="submit"
                variant="contained"
                id="apply-now-contact-form"
                size="small"
                disabled={isSubmitting}
                sx={{
                  width: { xs: "50%", md: "150px" },
                  fontSize: { xs: "14px", md: "16px" },
                }}
              >
                {isSubmitting ? "Submitting..." : "Apply"}
              </StyledButton>
            </Box>
          </Grid>
        </Box>
        <Box
          sx={{
            width: { xs: "100%", md: "40%" },
            display: "flex",
            height: "250px",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <Card
            sx={{
              flex: 1,
              borderRadius: "8px",
              boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
              transition: "transform 0.3s",

              "&:hover": {
                transform: isMobile ? "none" : "translateY(-4px)",
              },
            }}
          >
            <CardContent sx={{ p: isMobile ? 2 : 3 }}>
              <Typography
                variant={isMobile ? "subtitle1" : "h6"}
                gutterBottom
                sx={{ fontWeight: "bold", color: "#0265fe" }}
              >
                PSN FINANCE (P) LTD
              </Typography>
              <Typography
                variant={isMobile ? "body2" : "body1"}
                sx={{ whiteSpace: "pre-line", mb: 1 }}
              >
                No.380, Ittina Center, Ground Floor,
                <br />
                3rd Block 16th Main, Koramangala
                <br />
                Bengaluru - 560 034
              </Typography>
              <Typography
                variant={isMobile ? "caption" : "body2"}
                sx={{ color: "text.secondary" }}
              >
                <strong>CIN:</strong> U67190KA2010PTC053178
              </Typography>
              {/* <Typography
                variant={isMobile ? "caption" : "body2"}
                sx={{ color: "text.secondary", display: "block", mt: 0.5 }}
              >
                <strong>Reg. No:</strong> N - 02.00263
              </Typography> */}
              <Typography
                variant={isMobile ? "caption" : "body2"}
                sx={{
                  mt: 2,
                  fontFamily: "'Noto Sans Kannada', sans-serif",
                  display: "block",
                }}
              >
                ಪಿ ಎಸ್ ಎನ್ ಫೈನಾನ್ಸ್ ಪ್ರೈವೇಟ್ ಲಿಮಿಟೆಡ್
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Stack>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </>
  );
}
